import {
  Component,
  ViewChild,
  OnInit,
  Output,
  EventEmitter, Input
} from '@angular/core';

import { CostCenterService } from '../../../../../services/cost-center.service';
import { Modal } from 'src/app/components/modal/Modal';
import { UserService } from 'src/app/services/user.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts, MultiselectDropdownComponent } from 'angular-2-dropdown-multiselect';

@Component({
    selector: 'app-colabs-modal-change-group',
    providers: [CostCenterService, UserService],
    templateUrl: './colabs-modal-change-group.component.html',
})

export class ColabsModalChangeGroupComponent implements OnInit {
    @ViewChild('modalChangeGroup') modalGroup: Modal;
    @ViewChild('select') select: MultiselectDropdownComponent;
    @Output() saveGroupChange = new EventEmitter();

    @Input() set costCenters(costCenters: any) {
      this.costCentersList = costCenters;
      this.loadCostCenters();
    }

    costCentersList = [];
    selectedOption = [];
    optionsUnit: IMultiSelectOption[];
    settingsSelectUnit: IMultiSelectSettings = {
      enableSearch: false,
      checkedStyle: 'fontawesome',
      buttonClasses: 'btn btn-default btn-block',
      dynamicTitleMaxItems: 1,
      displayAllSelectedText: false,
      selectionLimit: 1,
      autoUnselect: true,
      closeOnClickOutside: true
    };

    selectTexts: IMultiSelectTexts = {
      checkAll: 'Selecionar todos',
      uncheckAll: 'Deselecionar todos',
      checked: 'grupo selecionado',
      checkedPlural: 'grupos selecionados',
      defaultTitle: 'Selecione o Grupo',
      allSelected: 'Grupos: todos',
    };

    constructor() {}

    ngOnInit() {}

    public loadCostCenters(): void {
      if (this.costCentersList) {
        this.optionsUnit = this.costCentersList.map((address) => (
          {id: address.id, name: address.name}
        ));
      }
    }

    saveChange() {
      if (this.selectedOption.length) {
        this.saveGroupChange.emit(this.selectedOption[0]);
      }
    }

    openModal() {
        this.modalGroup.open();
    }

    closeModal() {
        this.modalGroup.close();
    }
}
